module.exports = __webpack_public_path__ + "img/公众号二维码2.ab58d777.png";